var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 108.32 103.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: url(#linear-gradient);\n        stroke-miterlimit: 10;\n        stroke-width: 3.01px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 51.87,
    x2: 108.32,
    y2: 51.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ffc557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb62b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.5,4.87l12.77,26.76,29.4,3.88c4.93.65,6.91,6.73,3.3,10.15l-21.5,20.42,5.4,29.16c.91,4.89-4.26,8.65-8.64,6.28l-26.06-14.14-26.06,14.14c-4.37,2.37-9.54-1.38-8.64-6.28l5.4-29.16L3.35,45.66c-3.61-3.43-1.63-9.5,3.3-10.15l29.4-3.88,12.77-26.76c2.14-4.49,8.53-4.49,10.68,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.6423df36a0ba51507e6d6d0936ec3cd6.svg";
export { ForwardRef as ReactComponent };